import { JanelaModal } from '../../participantes/ui/JanelaModal';

interface ConfirmacaoDeAlocacaoProps {
    nome: string;
    /** Rótulos como "Grupo G04": o do grupo atual de quem será alocado (`null`: sem grupo) e o do aberto. */
    origem: string | null;
    destino: string;
    /** Só quando o alocado é o líder da origem e sobra outro ativo lá (`DP-RA-041`). */
    fraseDoLider?: string;
    processando: boolean;
    aoCancelar: () => void;
    aoConfirmar: () => void;
}

/** O popup "Alocar participante?" de `docs/img_refac/img_3.png`. */
export function ConfirmacaoDeAlocacao({
    nome, origem, destino, fraseDoLider, processando, aoCancelar, aoConfirmar,
}: ConfirmacaoDeAlocacaoProps) {
    return (
        <JanelaModal titulo="Alocar participante?" aoFechar={aoCancelar} bloqueada={processando}>
            {origem ? (
                <>
                    <p>{`${nome} já está alocado(a) no ${origem}.`}</p>
                    <p>
                        {`Ao transferi-lo(a) para o ${destino}, ele(a) perderá todo o seu progresso individual no ${origem} `
                            + `e retomará a jornada a partir da estação em que o ${destino} estiver.`}
                    </p>
                </>
            ) : (
                // Sem grupo não há grupo antigo nem progresso individual a perder (`DP-RA-039 b`).
                <p>
                    {`Ao transferi-lo(a) para o ${destino}, ele(a) retomará a jornada a partir da estação `
                        + `em que o ${destino} estiver.`}
                </p>
            )}
            {fraseDoLider && <p>{fraseDoLider}</p>}
            <div className="botoes-confirmacao">
                <button type="button" className="botao-secundario" onClick={aoCancelar} disabled={processando}>
                    Cancelar
                </button>
                <button type="button" className="botao-confirmar" onClick={aoConfirmar} disabled={processando}>
                    {processando ? 'Processando…' : 'Alocar'}
                </button>
            </div>
        </JanelaModal>
    );
}
